<div class="video-modal modal fade" *ngIf="videoDetails" id="{{modalid}}" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content" *ngIf="videoDetails">
      <div class="modal-header text-center bg-black border-0 p-0">
        <div class="col-3 text-white gold-border-right py-3" *ngFor="let item of videoDetails.rule_level"><span>{{item.rule_name | uppercase}}</span><br>
          <span class="text-gold">{{item.level_name | uppercase}}</span>
        </div>
      </div> 
      <video oncontextmenu="return false;" controlsList="nodownload" #videoFileContainer [poster]="getThumbUrl(videoDetails.video_thumb)" id="player" playsinline controls>
        <source src="{{getVideoUrl(videoDetails.video_url)}}" type="video/mp4">  
       </video>

      <div class="modal-body" >
        <div class="d-flex flex-row">
          <div class="modal-title text-uppercase text-black d-flex justify-content-start font-oswald me-auto">{{videoDetails?.name | uppercase}}
            <span class="stars-wrap" *ngIf="videoDetails.type=='video'">
              <ng-container *ngFor="let item of [].constructor(5); let i = index">
                <span class="fa fa-star" [ngClass]="videoDetails?.difficulty_rating>=
                (i+1)? 'rating-class':null"></span>
              </ng-container>
            </span>
            <i class="fa fa-heart ms-2" [ngClass]="videoDetails.fav==1?'text-red':''" *ngIf="webApi.isLoggedIn() && videoDetails.type=='series' && videoDetails.is_trailor==0" (click)="addToFav(videoDetails)"></i>
            <div class="popover-wrap ms-2" *ngIf="videoDetails.type=='video'">
              <div class="rating-info"><i class="fas fa-info"></i></div>
              <div class="popover-content">Difficulty rating coming soon</div>
            </div>
          </div>
          <!-- <button type="button" class="btn btn-success btn-sm me-2" *ngIf="webApi.isLoggedIn()" data-bs-toggle="modal" data-bs-target="#suggest-skill">{{'Suggest a Skill' | uppercase}}</button> -->
          <button type="button" class="btn btn-success btn-sm" *ngIf="webApi.isLoggedIn() && videoDetails.type!='series'" data-bs-toggle="modal" [attr.data-bs-target]="'#report-legality'+modalid">{{'Report a Legality' | uppercase}}</button>
        </div>
        <div *ngIf="videoDetails.type=='video'" class="info mx-1 my-2 bg-gold label-gold">{{videoDetails.cat | uppercase}}</div>
        <span class="info mx-1 my-2 label-black" *ngFor="let skill of videoDetails.skills">{{skill.name | uppercase}}</span>
        <i class="fa fa-heart ms-2" [ngClass]="videoDetails.fav==1?'text-red':''" *ngIf="webApi.isLoggedIn() && videoDetails.type=='video'" (click)="addToFav(videoDetails)"></i>
        
        <p class="my-2" [innerHTML]="videoDetails.description" *ngIf="videoDetails.type!='series'"></p>
        <ul class="nav nav-pills bg-black mt-3 rounded-3 font-oswald" id="pills-tab" role="tablist" *ngIf="videoDetails.type=='video'">

          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="pills-instructor-tab" data-bs-toggle="pill"
              data-bs-target="#pills-instructor" type="button" role="tab" aria-controls="pills-instructor"
              aria-selected="false">INSTRUCTOR TALKING POINTS</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-options-tab" data-bs-toggle="pill" data-bs-target="#pills-options"
              type="button" role="tab" aria-controls="pills-options" aria-selected="true"> Definitions</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-errors-tab" data-bs-toggle="pill"
              data-bs-target="#pills-errors" type="button" role="tab" aria-controls="pills-errors"
              aria-selected="false">COMMON ERRORS</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-leagal-tab" data-bs-toggle="pill"
              data-bs-target="#pills-leagal" type="button" role="tab" aria-controls="pills-leagal"
              aria-selected="false">LEGALITY TIPS</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-notes-tab" data-bs-toggle="pill"
              data-bs-target="#pills-notes" type="button" role="tab" aria-controls="pills-notes"
              aria-selected="false">OTHER NOTES</button>
          </li>
        </ul>
        <div class="tab-content bullets-change p-3" id="pills-tabContent" *ngIf="videoDetails.type=='video'">
          <div class="tab-pane fade" id="pills-options" role="tabpanel" aria-labelledby="pills-options-tab"
            tabindex="0">
            <table>
              <tr *ngFor="let option of videoDetails.videos_options">
                <th>{{option.option_name}}</th>
                <td>{{option.choice_name}}</td>
              </tr>
            </table>
          </div>
          <div class="tab-pane fade show active" id="pills-instructor" role="tabpanel" aria-labelledby="pills-instructor-tab"
            tabindex="1">
            <ul>
              <li *ngFor="let skill of videoDetails.instructions">{{skill.text}}</li>
            </ul>
          </div>

          <div class="tab-pane fade" id="pills-errors" role="tabpanel" aria-labelledby="pills-errors-tab"
            tabindex="2">
            <ul><li *ngFor="let skill of videoDetails.commonerrors">{{skill.text}}</li></ul>
          </div>
          <div class="tab-pane fade" id="pills-leagal" role="tabpanel" aria-labelledby="pills-leagal-tab"
            tabindex="3" >
            <ul>
              <li *ngFor="let skill of videoDetails.legalitytips">{{skill.text}}</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="pills-notes" role="tabpanel" aria-labelledby="pills-notes-tab"
            tabindex="4">
            <ul>
              <li *ngFor="let skill of videoDetails.notes">{{skill.text}}</li>
            </ul>
          </div>

        </div>
      </div>
      <div class="modal-footer d-flex justify-content-evenly align-items-center border-top-0" *ngIf="videoDetails.type!='series'">
        <button type="button" class="btn btn-gold btn-primary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


  <div class="modal fade" *ngIf="webApi.isLoggedIn()" id="report-legality{{modalid}}" tabindex="-1" aria-labelledby="reportlegalityModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <form class="signup-form" [formGroup]="legalityForm" (ngSubmit)="onSubmitLegality(legalityForm)">
          <div class="modal-body">
            <h5 class="mb-4">Report a Legality</h5>
              <!-- <div class="form-group">
                  <label for="emailInput" class="form-label">Your Email address</label>
                  <input type="email" class="form-control" formControlName="email" id="emailInput">
                  <div class="invalid-feedback d-block"
                      *ngIf="(f1['email'].errors?.['required'] || f1['email'].errors?.['email']) && (f1['email'].dirty || f1['email'].touched)">
                      Please fill valid email.
                  </div>
              </div>
              <div class="form-group">
                  <label for="" class="form-label">Name:</label>
                  <input type="text" class="form-control" formControlName="name">
                  <div class="invalid-feedback d-block"
                      *ngIf="f1['name'].errors?.['required'] && (f1['name'].dirty || f1['name'].touched)">
                      Please fill name.
                  </div>
              </div>
              <div class="form-group">
                  <label for="" class="form-label">Profession:</label>
                  <input type="text" class="form-control" formControlName="profession">
                  <div class="invalid-feedback d-block"
                      *ngIf="f1['profession'].errors?.['required'] && (f1['profession'].dirty || f1['profession'].touched)">
                      Please fill profession.
                  </div>
              </div> -->
              <div class="form-group">
                  <label for="" class="form-label">Message:</label>
                  <textarea type="text" class="form-control" formControlName="message"></textarea>
                  <div class="invalid-feedback d-block"
                      *ngIf="f1['message'].errors?.['required'] && (f1['message'].dirty || f1['message'].touched)">
                      Please write a message.
                  </div>
              </div>
          </div>
          <div class="d-flex justify-content-end mt-3">
              <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-gold">Submit <i *ngIf="legalitySubmitting" class="fa fa-spinner fa-spin"></i></button>
          </div>
           
        </form>
      </div>
    </div>
  </div>